export default "__VITE_ASSET__004b679c__"